import { MenuItem } from '@mui/material';
import React, { ReactElement } from 'react';
import { DEFAULT_OFFER_API_STATE } from '../../../../constants';
import { UserField } from '../../../../constants/user-labels';
import { DataFiltersModel } from '../../../../models';
import { GtSelect } from '../../../gt-select/GtSelect';
import { stateFilterOptions } from './StateFilter.const';

interface UserFilterProps {
  className: string;
  state: string;
  onFiltersChange?: (filters: DataFiltersModel) => void;
}

export function StateFilter({
  className,
  state,
  onFiltersChange,
}: UserFilterProps): ReactElement {
  const onFilterChanged = (event) => {
    const { value } = event.target;

    onFiltersChange({
      filterByActive: value,
    });
  };

  return (
    <GtSelect
      className={className}
      variant="outlined"
      size="small"
      fullWidth
      disabled={false}
      value={state || DEFAULT_OFFER_API_STATE}
      onChange={onFilterChanged}
      name={UserField.Role}
      label="Filter by state"
      inputProps={{
        name: 'stateFilter',
        id: 'stateFilter',
      }}
    >
      {stateFilterOptions.map(({ value, title }) => (
        <MenuItem key={value} value={value}>
          {title}
        </MenuItem>
      ))}
    </GtSelect>
  );
}
